import { useIntl } from 'react-intl';
import { Checkbox, Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import {
  CompaniesInfiniteSelectField,
  DocumentTypesInfiniteSelectField,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import moment from 'moment';
import { ListInstallmentsQuery } from '@/core/domain/financial/AccountPayable/AccountPayable.types';

export default function AccountPayableListExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListInstallmentsQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} lg={4} md={12}>
        <Input
          value={queryParams?.code}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, code: value }))
          }
          placeholder={intl.formatMessage({
            id: 'releaseBillToPay.list.header.code',
          })}
        />
      </Col>

      <Col span={24} lg={10} md={12}>
        <CompaniesInfiniteSelectField
          value={queryParams?.companyId}
          placeholder={intl.formatMessage({
            id: 'releaseBillToPay.list.header.companies',
          })}
          allowClear
          style={{ width: '100%' }}
          onChange={(values) =>
            setQueryParams((prev) => ({ ...prev, companyId: values }))
          }
        />
      </Col>

      <Col span={24} lg={10} md={12}>
        <Input
          value={queryParams?.creditor}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, creditor: value }))
          }
          placeholder={intl.formatMessage({
            id: 'releaseBillToPay.list.header.creditor',
          })}
        />
      </Col>

      <Col span={24} lg={10} md={12}>
        <Input
          value={queryParams?.description}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, description: value }))
          }
          placeholder={intl.formatMessage({
            id: 'releaseBankEntry.list.header.description',
          })}
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <Input
          value={queryParams?.documentNumber}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, documentNumber: value }))
          }
          placeholder={intl.formatMessage({
            id: 'releaseBillToPay.list.header.documentNumber',
          })}
        />
      </Col>

      <Col span={24} lg={8} md={12}>
        <DocumentTypesInfiniteSelectField
          value={queryParams?.documentTypeId}
          placeholder={intl.formatMessage({
            id: 'releaseBillToPay.list.header.documentType',
          })}
          allowClear
          style={{ width: '100%' }}
          onChange={(values) =>
            setQueryParams((prev) => ({ ...prev, documentTypeId: values }))
          }
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <InputDate
          placeholder="Data de emissão"
          value={
            queryParams?.emissionDate
              ? moment(queryParams?.emissionDate)
              : undefined
          }
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              emissionDate: value?.toISOString(),
            }))
          }
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <InputDate
          placeholder={intl.formatMessage({
            id: 'releaseBillToPay.list.header.dueDate',
          })}
          value={
            queryParams?.dueDate ? moment(queryParams?.dueDate) : undefined
          }
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              dueDate: value?.toISOString(),
            }))
          }
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <InputDate
          placeholder="Data de pagamento"
          value={
            queryParams?.payDate ? moment(queryParams?.payDate) : undefined
          }
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              payDate: value?.toISOString(),
            }))
          }
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <InputDecimal
          value={queryParams?.installmentValue}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              installmentValue: value,
            }))
          }
          placeholder={intl.formatMessage({
            id: 'releaseBillToPay.list.header.value',
          })}
        />
      </Col>

      <Col span={24} lg={6} md={12}>
        <Checkbox
          onChange={(e) => {
            setQueryParams((prev) => ({
              ...prev,
              rows: e.target.checked ? 500 : 10,
            }));
          }}
          style={{ fontWeight: 'bold' }}
        >
          Listar todos
        </Checkbox>
      </Col>
    </Row>
  );
}
